

import {drawFrame,drawFrameSkeleton} from '@kemtai/skeleton-api';
import {Keypoints, PointName} from '@kemtai/skeleton-api';


const lineColor = 'cyan';
const pointColor = 'white';

const BONES = [
  ['neck', 'right_shoulder'],
  ['neck', 'left_shoulder'],

  ['right_shoulder', 'right_elbow'],
  ['right_elbow', 'right_wrist'],
  ['right_hip', 'right_knee'],
  ['right_knee', 'right_ankle'],
  ['right_ankle', 'right_bigtoe'],

  ['left_shoulder', 'left_elbow'],
  ['left_elbow', 'left_wrist'],
  ['left_hip', 'left_knee'],
  ['left_knee', 'left_ankle'],
  ['left_ankle', 'left_bigtoe'],


  ['neck_top', 'neck', 'inverse'],
  ['neck', 'front_1', 'inverse'],
  ['front_1', 'front_2', 'inverse'],
  ['front_2', 'front_3', 'inverse'],
  ['front_3', 'front_4', 'inverse'],
  ['front_4', 'front_5', 'inverse'],


  ['back_neck_top', 'neck_back', 'inverse'],
  ['neck_back', 'back_1', 'inverse'],
  ['back_1', 'back_2', 'inverse'],
  ['back_2', 'back_3', 'inverse'],
  ['back_3', 'back_4', 'inverse'],
  ['back_4', 'back_5', 'inverse'],


  ['left_hip', 'back_5'],
  ['right_hip', 'back_5'],
  ['left_hip', 'front_5'],
  ['right_hip', 'front_5'],

  ['right_wrist', 'right_middle_finger1'],
  ['left_wrist', 'left_middle_finger1'],
];



export function drawSkeleton(canvas: HTMLCanvasElement,  kp: Keypoints|null,   img: ImageBitmap|ImageData|null) {
    if (!canvas) {
        return;
    }
    drawFrameSkeleton(canvas, img, kp);
    return;

    /*
    const context = canvas.getContext('2d');
    if (!context) {
        return;
    }   
    if (img) {
        drawFrame(canvas, img);
    } else {
        // fill the canvas with black
        context.fillStyle = '#707070';
        context.fillRect(0, 0, canvas.width, canvas.height);

    }
    if (!kp) {
        return;
    }


    //context.globalAlpha = 0.5;

    for (let p of kp.points()) {
        drawPoint(context, kp, p)
    }
    for (let bone of BONES) {
        drawLine(context, kp, bone)
    }
    //context.globalAlpha = 1;
    */
}



function drawLine(Context: CanvasRenderingContext2D, kp: Keypoints, bone: string[]) {
  const [start, end] = bone;
  const startPoint = kp.get(start as PointName);
  if (!startPoint) {
    return;
  }
  const endPoint = kp.get(end as PointName);
  if (!endPoint) {
    return;
  }

  // Set the line color to white, width to 4
  Context.strokeStyle = lineColor
  Context.lineWidth = 3;
  Context.beginPath();
  Context.moveTo(startPoint.x, startPoint.y);
  Context.lineTo(endPoint.x, endPoint.y);
  Context.stroke();
}

function drawPoint(Context: CanvasRenderingContext2D, kp: Keypoints, point: PointName) {
  const p = kp.get(point);
  if (!p) {
    return;
  }
  // Set the point color to red, size to 5
  Context.fillStyle = pointColor
  Context.beginPath();
  Context.arc(p.x, p.y, 3.5, 0, 2 * Math.PI);
  Context.fill();
}

